import React from "react";
import { Link } from "react-router-dom";
import Marquee from "react-fast-marquee";
import heroBg from "../../images/bg/hero_bg.png";
import learningImage from "../../images/bg/hero_bg02.jpg";
import featureBg from "../../images/bg/feature-bg.jpg";
import {
  audiences,
  organisation,
  pedagogyItems,
  trainings,
} from "../../data/clearith";
import CourseCard from "./CourseCard";

const HomeContent: React.FC = () => {
  const training = trainings[0];

  return (
    <>
      <section
        className="cl-hero bg_img"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="container">
          <div className="row align-items-center gy-5">
            <div className="col-xl-7 col-lg-7">
              <div className="cl-hero__content">
                <span className="cl-eyebrow wow fadeInUp">
                  Organisme de formation certifié Qualiopi
                </span>
                <h1 className="wow fadeInUp" data-wow-delay="100ms">
                  Développez et certifiez vos{" "}
                  <span>compétences professionnelles</span>
                </h1>
                <p className="wow fadeInUp" data-wow-delay="200ms">
                  CLEARITH vous accompagne à travers des parcours structurés,
                  interactifs et adaptés à vos objectifs professionnels.
                </p>
                <div
                  className="cl-hero__actions wow fadeInUp"
                  data-wow-delay="300ms"
                >
                  <Link className="thm-btn agency-btn" to="/formations">
                    <span className="text">Découvrir nos formations</span>
                  </Link>
                  <Link className="cl-outline-btn" to="/contact">
                    Nous contacter <span aria-hidden="true">↗</span>
                  </Link>
                </div>
                <div className="cl-hero__trust wow fadeInUp" data-wow-delay="400ms">
                  <span>
                    <i aria-hidden="true">✓</i> Certification Qualiopi
                  </span>
                  <span>
                    <i aria-hidden="true">✓</i> Actions de formation
                  </span>
                  <span>
                    <i aria-hidden="true">✓</i> Accompagnement personnalisé
                  </span>
                </div>
              </div>
            </div>
            <div className="col-xl-5 col-lg-5">
              <div className="cl-hero-panel wow zoomIn" data-wow-delay="200ms">
                <div className="cl-hero-panel__head">
                  <span>Parcours à la une</span>
                  <span className="cl-live-dot">À distance</span>
                </div>
                <div className="cl-hero-panel__body">
                  <span className="cl-rs-badge">RS6905</span>
                  <h2>VTest Business English</h2>
                  <p>4 Skills · 4 modules · Certification incluse</p>
                  <div className="cl-progress" aria-label="Quatre compétences préparées">
                    {training.skills.map((skill, index) => (
                      <span key={skill} title={skill}>
                        {index + 1}
                      </span>
                    ))}
                  </div>
                  <ul>
                    {training.skills.map((skill) => (
                      <li key={skill}>{skill}</li>
                    ))}
                  </ul>
                  <Link to={`/formations/${training.slug}`}>
                    Voir la fiche complète <span aria-hidden="true">→</span>
                  </Link>
                </div>
                <div className="cl-hero-panel__metric">
                  <strong>28 h</strong>
                  <span>de formation</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="cl-audience-strip" aria-label="Publics accompagnés">
        <Marquee speed={42} gradient={false} pauseOnHover>
          {audiences.concat(audiences).map((audience, index) => (
            <span key={`${audience}-${index}`}>
              {audience} <i aria-hidden="true">✦</i>
            </span>
          ))}
        </Marquee>
      </section>

      <section className="cl-intro cl-section">
        <div className="container">
          <div className="row align-items-end gy-4">
            <div className="col-lg-7">
              <span className="cl-kicker">CLEARITH, organisme de formation</span>
              <h2 className="cl-section-title xb-text-reveal">
                Des compétences opérationnelles pour faire avancer votre
                parcours professionnel.
              </h2>
            </div>
            <div className="col-lg-5">
              <p className="cl-lead">
                Nous concevons des parcours qui associent accompagnement
                pédagogique, pratique professionnelle, évaluations régulières
                et préparation à la certification.
              </p>
              <Link className="cl-text-link" to="/a-propos">
                Découvrir CLEARITH <span aria-hidden="true">↗</span>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="cl-training-highlight cl-section">
        <div className="container">
          <div className="cl-section-heading">
            <div>
              <span className="cl-kicker">Notre formation certifiante</span>
              <h2 className="cl-section-title">
                L’anglais professionnel, dans les quatre compétences.
              </h2>
            </div>
            <Link className="cl-outline-btn" to="/formations">
              Voir les formations
            </Link>
          </div>
          <CourseCard training={training} featured />
        </div>
      </section>

      <section className="cl-keyfacts">
        <div className="container">
          <div className="cl-keyfacts__grid">
            {[
              ["28 h", "Durée totale"],
              ["4 × 7 h", "Organisation"],
              ["4–8 sem.", "Rythme indicatif"],
              ["4 skills", "Compétences évaluées"],
            ].map(([value, label]) => (
              <div className="cl-keyfact" key={label}>
                <strong>{value}</strong>
                <span>{label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section
        className="cl-pedagogy cl-section bg_img"
        style={{ backgroundImage: `url(${featureBg})` }}
      >
        <div className="container">
          <div className="cl-section-heading">
            <div>
              <span className="cl-kicker">Méthode pédagogique</span>
              <h2 className="cl-section-title">Apprendre, pratiquer, progresser.</h2>
            </div>
            <p className="cl-lead">
              Chaque étape du parcours vise l’acquisition de compétences utiles,
              mobilisables et évaluées.
            </p>
          </div>
          <div className="row g-4">
            {pedagogyItems.map((item) => (
              <div className="col-lg-4 col-md-6" key={item.number}>
                <article className="cl-method-card xb-border wow fadeInUp">
                  <span>{item.number}</span>
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </article>
              </div>
            ))}
          </div>
          <div className="cl-centered-action">
            <Link className="thm-btn agency-btn" to="/methode-pedagogique">
              <span className="text">Notre méthode en détail</span>
            </Link>
          </div>
        </div>
      </section>

      <section className="cl-quality cl-section">
        <div className="container">
          <div className="row align-items-center gy-5">
            <div className="col-lg-6">
              <div
                className="cl-quality__image bg_img"
                style={{ backgroundImage: `url(${learningImage})` }}
                role="img"
                aria-label="Professionnel participant à une classe virtuelle"
              >
                <div className="cl-quality__badge">
                  <strong>QUALIOPI</strong>
                  <span>Actions de formation</span>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <span className="cl-kicker">Engagement qualité</span>
              <h2 className="cl-section-title">
                Un cadre clair, un suivi attentif, un parcours accessible.
              </h2>
              <p className="cl-lead">
                CLEARITH est certifié Qualiopi pour ses actions de formation et
                veille à proposer un accompagnement individualisé tout au long
                du parcours.
              </p>
              <ul className="cl-check-list">
                <li>Objectifs et modalités présentés avant l’entrée en formation</li>
                <li>Suivi de la progression et évaluations régulières</li>
                <li>Échange préalable sur les besoins d’accessibilité</li>
              </ul>
              <Link className="cl-text-link" to="/accessibilite">
                En savoir plus sur l’accessibilité <span aria-hidden="true">↗</span>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="cl-access-cta">
        <div className="container">
          <div className="cl-access-cta__inner">
            <div>
              <span className="cl-kicker">Un projet de formation ?</span>
              <h2>Échangeons sur votre objectif professionnel.</h2>
              <p>
                Recevez les informations utiles sur le programme, les modalités
                et les solutions de financement envisageables.
              </p>
            </div>
            <div className="cl-access-cta__actions">
              <Link className="thm-btn agency-btn" to="/contact">
                <span className="text">Demander des informations</span>
              </Link>
              <a className="cl-outline-btn" href={`mailto:${organisation.email}`}>
                {organisation.email}
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomeContent;
